/* 路由配置 */
import {SERVICE_LINK} from "@/constant/_Public/Path";

export const PART_TIME = '/part-time';  // 招聘页
export const FEEDBACK = '/feedBack';    // 意见反馈


/* 其他链接配置 */
export const SERVICE = SERVICE_LINK;    // 人工客服
